/// <amd-module name="Build/Common/Artifacts/providers/VersionControl" />
import * as Resources from "Build/Common/Artifacts/Resources";

import { Base } from "Build/Common/Artifacts/providers/Base";
import { BuildArtifactTypes, IDisplayOptions } from 'Common';
import { format } from 'VSS/Core/Util/String';
export class VersionControl extends Base {
    public getKey() {
        return BuildArtifactTypes.VersionControl;
    }

    public getDisplayOptions(): IDisplayOptions {
        return {
            text: this.artifact.name,
            iconName: "TFVCLogo",
            tooltip: format(Resources.BuildArtifactLabelFormat, this.artifact.name),
            type: this.getType()
        }
    }
}
